import { render, staticRenderFns } from "./AtividadesUnidade.vue?vue&type=template&id=3b3a9572&scoped=true"
import script from "./AtividadesUnidade.vue?vue&type=script&lang=js"
export * from "./AtividadesUnidade.vue?vue&type=script&lang=js"
import style0 from "./AtividadesUnidade.vue?vue&type=style&index=0&id=3b3a9572&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b3a9572",
  null
  
)

export default component.exports